<footer class="app-footer">
  <div class="container footer-shell">
    <div class="footer-brand">Konvac</div>
    <div class="footer-copy">Copyright &copy; <span>2026</span> Konvac. All rights reserved.</div>
  </div>
</footer>
